export const SCORE_CARD_RESULT_MESSAGE = {
  NOT_FOUND:
    "Missing Score Card Risk Factors, upload new Score Card before continuing.",
};



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/scoreCardsResultMessage.js